import { render, staticRenderFns } from "./app-top-navbar.vue?vue&type=template&id=04ff8f10&"
import script from "./app-top-navbar.vue?vue&type=script&lang=js&"
export * from "./app-top-navbar.vue?vue&type=script&lang=js&"
import style0 from "./app-top-navbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports